var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"notificationsettings",attrs:{"aria-labelledby":_vm.id}},[_c('div',{staticClass:"notificationsettings_title"},[_c('h1',{attrs:{"id":_vm.id,"data-focus":""}},[_vm._v(_vm._s(_vm.$t('notificationsettings.title')))])]),_c('notification-settings-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }